<template>
  <div class="microphone-detect-wrapper">
    <div style="height: 30px;" />
      <div v-if="recordEvent === info.ready" class="guilde-text-wrapper">
        <p>请点击下方麦克风按钮，大声读出下面一段话，完成麦克风检测</p>
      </div>

      <div v-if="recordEvent === info.play" class="guilde-text-wrapper">
        <p>请根据您收听的结果，选择结果按钮。录制无声音，解决方案<span class="guide-btn">点此查看>></span> </p>
      </div>

      <div
        v-if="
          recordEvent === info.recording ||
          recordEvent === info.end ||
          recordEvent === info.finish
        "
        style="margin-bottom: 19.6px"
        class="guilde-text-wrapper"
      >
        <p v-if="recordEvent === info.recording">
          正在录制，请稍等<span class="time-num">{{ num }}</span
          ><span class="time">s</span>…
        </p>
        <p v-else-if="recordEvent === info.end || recordEvent === info.finish">
          请点击下方播放按钮，收听您刚刚读的文字
        </p>
      </div>

    <div class="audio-wrap">
      <span v-if="recordEvent === info.ready" />
      <span
        v-else-if="recordEvent === info.finish || recordEvent === info.end"
        class="wave"
      ></span>
      <img
        v-else
        class="moire"
        src="https://dev-cdn-common.codemao.cn/dev/27/public-edu/5/moire/moire.gif"
        alt=""
      />
      <div class="func-wrap">
        <div class="func-tooltip">麦克风测试</div>
        <span
          v-if="recordEvent === info.ready"
          class="microphone microphone-hover"
          @click="startAudio"
        ></span>
        <span
          v-else-if="
            recordEvent === info.recording || recordEvent === info.play
          "
          class="stop"
          @click="stopAudio"
        ></span>
        <span
          v-else-if="
            recordEvent === info.finish ||
            recordEvent === info.error ||
            recordEvent === info.end
          "
          class="play microphone-hover"
          @click="playAudio"
        ></span>
      </div>

      <span v-if="recordEvent === info.ready" />
      <span
        v-else-if="recordEvent === info.finish || recordEvent === info.end"
        class="wave"
      ></span>
      <img
        v-else
        class="moire"
        src="https://dev-cdn-common.codemao.cn/dev/27/public-edu/5/moire/moire.gif"
        alt=""
      />
    </div>
    <audio
      ref="audioDom"
      @ended="finishAudio"
      v-show="false"
      controls
      playsinline
      :src="audioSrc"
    ></audio>

    <button
      @click="startAudio"
      v-if="recordEvent !== info.ready && recordEvent !== info.recording"
      class="re-record-btn"
    >
      重新录制
    </button>
    <p class="tip error" v-if="recordEvent === info.error">麦克风录制异常</p>
  </div>
</template>

<script>
import RecordRTC from 'recordrtc'
export default {

  inject: ['setDetectInfo'],
  data() {
    return {
      recorderRTC: '', // rtc对象
      stream: null, // 录制的流对象
      audioContext: '',
      recordEvent: 0, // 录制事件
      microphone: '',
      num: 5, // 读秒
      info: {
        ready: 0, // 准备中
        recording: 1, // 录制中
        play: 2, // 播放中
        error: 3, // 异常
        end: 4, // 录制结束
        finish: 5 // 完成
      },
      audioSrc: '' // 录音的链接
    }
  },
  mounted() {
    // this.init()
    // 音频节点
    this.audioContext = new AudioContext()
  },
  destroyed() {
    clearInterval(this.timer)
    if (this.stream) {
      this.stream.stop()
    }
    if (this.recorderRTC) {
      this.recorderRTC.destroy()
    }
  },
  methods: {
    // 初始化
    countdown() {
      // if (this.recordEvent !== this.info.recording) return
      this.num = 5
      clearInterval(this.timer)

      this.timer = setInterval(() => {
        this.num -= 1
        if (this.num <= 0) {
          clearInterval(this.timer)
          this.num = 5
          this.stopAudio()
        }
      }, 1000)
    },
    async init() {
      this.recorderRTC = ''
      this.stream = null
      if (!navigator.mediaDevices.getUserMedia) {
        // this.$emit('setMicroInfo', 'a')
        return
      }
      const contrains = {
        audio: {
          sampleRate: 48000,
          channelCount: 1,
          echoCancellation: false
        }
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia(contrains)
      } catch (error) {
        this.handleError(error)
      }
    },
    async startAudio() {
      this.recorderRTC = ''
      this.stream = null
      if (!navigator.mediaDevices.getUserMedia) {
        this.$emit('setMicroInfo', 'a')
        return
      }
      const contrains = {
        audio: {
          sampleRate: 48000,
          channelCount: 1,
          echoCancellation: false
        }
      }
      // 加倒计时
      this.countdown()
      try {
        this.stream = await navigator.mediaDevices.getUserMedia(contrains)
        this.recorderRTC = new RecordRTC(this.stream, {
          type: 'audio'
        })
        // 开始录制
        this.recorderRTC.startRecording()
        this.recordEvent = this.info.recording
      } catch (error) {
        console.log(error, 'error')
        this.handleError(error)
      }
    },
    stopAudio() {
      // 录制时
      if (this.recordEvent === this.info.recording) {
        this.recorderRTC.stopRecording(this.stopRecordingCallback)
        // 关闭
        this.stream.stop()
        this.stream = null
      }
    },
    playAudio() {
      this.recordEvent = this.info.play
      this.$refs.audioDom.play()
    },
    // 完成后
    finishAudio() {
      this.recordEvent = this.info.finish
      this.$emit('record-finsh')
    },
    handleError(error) {
      this.$emit('record-error', error.name)
      switch (error.name) {
        case 'NotAllowedError':
          this.$message.error('请允许访问麦克风')
          break
        case 'OverConstrainedError':
          this.$message.error('麦克风被占用或者分辨率不支持')
          break
        case 'NotFoundError':
          this.$message.error('没有找到设备')
          break
        case 'NotReadableError':
          this.$message.error('麦克风被占用或者分辨率不支持')
          break
        case 'AbortError':
          this.$message.error('操作被中止')
          break
        default:
          this.$message.error('录制失败')
          break
      }
    },
    stopRecordingCallback() {
      this.replaceAudio(URL.createObjectURL(this.recorderRTC.getBlob()))
      // TODO:硬加的 就特么这样吧
      setTimeout(() => {
        this.playAudio()
      }, 100)
    },
    replaceAudio(src) {
      if (src) {
        this.audioSrc = src
      }
    },
    setInfo(val) {
      this.$emit('setMicroInfo', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.microphone-detect-wrapper {
  margin-left: 130px;
  flex: 1;
}

.re-record-btn {
  margin-top: 8px;
  width: 154px;
  height: 36px;
  border-radius: 8px;
  background-color: #ffffff;
  border: solid #b9c0d4 1px;
  color: #404968;
  cursor: pointer;
}

.re-record-btn:hover {
  background-color: #f1f3f5;
}
.re-record-btn:active {
  background-color: #e4e7f0;
}

.tip {
  color: #333;
  font-size: 16px;
}
.play-tip {
  margin: 90px auto -17px;
  font-weight: 400;
  color: #333;
  span {
    font-size: 18px;
    font-weight: 500;
  }
}
.play-no-txt {
  margin: 148px auto -17px;
}
.error {
  color: #ff5030;
  font-weight: 300;
}
.time-num {
  font-weight: 500;
}
.time {
  margin-left: 2px;
  font-weight: 400;
}
.sure-btn {
  margin-left: 60px;
  @include theme-fill-btn(144px, 42px, 16px, 4px);
}
.restart-btn {
  @include theme-empty-btn(144px, 42px, 16px, 4px);
}
.top-tip {
  padding: 16px 0;
  font-weight: 500;
  color: #242833;
  font-size: 20px;
  line-height: 28px;
}
.dialog {
  position: relative;
  width: 260px;
  margin: auto;
  height: 30px;
  line-height: 30px;
  background: #00c882;
  border-radius: 18px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  &::after {
    content: '';
    position: absolute;
    border: 7px solid transparent;
    border-bottom: 9px solid #00c882;
    top: -14px;
    right: 30px;
  }
}
.audio-wrap {
  display: flex;
  position: relative;
  align-items: center;
  margin: 60px auto 7px;
  width: 292px;
  height: 98px;
}

.moire {
  width: 79px;
  height: 54px;
  // background: #000;
}
.wave {
  width: 79px;
  height: 54px;
  background: url('~@/assets/images/detect/wave.png') no-repeat center / cover;
}
.func-wrap {
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  background: linear-gradient(
    270deg,
    rgba(59, 141, 255, 1) 0%,
    rgba(48, 111, 255, 1) 100%
  );

  box-shadow: 0px 4px 10px 0px rgba(48, 111, 255, 0.41);
  align-items: center;
  margin: auto;
  z-index: 2;
  border-radius: 50%;
  &:hover {
    background: #8ba4f8;
  }
  &:active {
    background: #3853e2;
  }
  .func-tooltip {
    position: absolute;
    color: #000000D9;
    font-size: 16px;
    padding: 6px 24px;
    min-width: 128px;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(206,219,241,0.8);
    border-radius: 6px;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);

  }
  .func-tooltip::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: #ffffff;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }
  span {
    cursor: pointer;
    width: 95px;
    height: 95px;
  }
  .microphone {
    background: url('~@/assets/images/detect/microphone.png') no-repeat center /
      28px 37px;
  }
  .play {
    background: url('~@/assets/images/detect/play.png') no-repeat 26px 33px /
      26px 30px;
  }
  .stop {
    background: url('~@/assets/images/detect/stop.png') no-repeat center / 20px
      29px;
  }
}
.btn-wrap {
  display: flex;
  justify-content: center;
  margin: 33px 0 50px;
}
</style>
